import { render, staticRenderFns } from "./ActivityConfigInitializePreviewModal.vue?vue&type=template&id=8c8e8d84&scoped=true"
import script from "./ActivityConfigInitializePreviewModal.vue?vue&type=script&lang=js"
export * from "./ActivityConfigInitializePreviewModal.vue?vue&type=script&lang=js"
import style0 from "./ActivityConfigInitializePreviewModal.vue?vue&type=style&index=0&id=8c8e8d84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8e8d84",
  null
  
)

export default component.exports